import React, { useState } from "react";
import "./manage-membership-modal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { addCommas } from "../../helpers/helpers";

const ManageMembershipModal = (props) => {
  const { individualMembershipData } = props;
  const [selected, setSelected] = useState(
    props.memberships.memberships.length ===
      individualMembershipData.memberships.length &&
      !individualMembershipData.memberships.some(
        (membership) => membership.status === "locked" //eslint-disable-line
      )
      ? individualMembershipData.memberships.find(
          (membership) => membership.status === "unLocked" //eslint-disable-line
        )
      : props.memberships.memberships.length ===
            individualMembershipData.memberships.length &&
          individualMembershipData.memberships.some(
            (membership) =>
              membership.status === "locked" &&
              membership.strategyName === "currentInvestmentsAndFuturePayments" //eslint-disable-line
          )
        ? individualMembershipData.memberships.find(
            (membership) =>
              !(
                membership.status === "locked" &&
                membership.strategyName ===
                  "currentInvestmentsAndFuturePayments"
              ) &&
              !(
                membership.memberType?.includes("deferred") &&
                membership.status === "locked"
              ) //eslint-disable-line
          )
        : props.memberships.memberships.length ===
              individualMembershipData.memberships.length &&
            individualMembershipData.memberships.some(
              (membership) =>
                (membership.status === "locked" ||
                  membership.status === "unLocked") &&
                membership.strategyName !==
                  "currentInvestmentsAndFuturePayments" &&
                !(
                  membership.memberType?.includes("deferred") &&
                  membership.status === "locked"
                ) //eslint-disable-line
            )
          ? individualMembershipData.memberships.find(
              (membership) =>
                (membership.status === "locked" ||
                  membership.status === "unLocked") &&
                membership.strategyName !==
                  "currentInvestmentsAndFuturePayments" &&
                !(
                  membership.memberType?.includes("deferred") &&
                  membership.status === "locked"
                ) //eslint-disable-line
            )
          : props.memberships.memberships[0] //eslint-disable-line
  );
  function handleCheck(item) {
    setSelected(item);
  }
  const date = new Date(individualMembershipData?.correctDate);
  const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${date.getFullYear().toString()}`;

  return (
    <div className="manage-membership-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="manage-membership-modal-body">
        <div className="mm-parent-heading d-none d-xl-flex d-lg-flex d-md-flex">
          <div>
            <p className="heading mb-3">{props.modalTitle}</p>
            <span className="mb-3">You can select one pot at a time.</span>
          </div>
          <div className="mm-parent-total-value">
            <div className="mm-total-value-head">Total value</div>
            <span className="mm-total-value">
              £{addCommas(Math.trunc(individualMembershipData?.totalFund))}.
              <span className="penny-value">
                {(individualMembershipData?.totalFund % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>
            </span>
          </div>
        </div>
        <div className="d-block d-sm-none">
          <div>
            <p className="heading mb-3">{props.modalTitle}</p>
          </div>
          <div className="mb-3">You can select one pot at a time.</div>
          <div className="mm-parent-total-value mb-3">
            <div className="">Total value</div>
            <span className="">
              £{addCommas(Math.trunc(individualMembershipData?.totalFund))}.
              <span className="penny-value">
                {(individualMembershipData?.totalFund % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>
            </span>
          </div>
        </div>
        {individualMembershipData?.memberships?.some(
          (membership) =>
            (membership.memberType?.includes("deferred") &&
              membership.status === "locked") ||
            (membership.status === "locked" &&
              membership.strategyName === "currentInvestmentsAndFuturePayments") //eslint-disable-line
        ) ? (
          <div className="mm-locked-text d-flex mt-3">
            <span className="locked-pad">
              <Icons iconname="locked" variant="icon-sixteen-px" />
            </span>
            <p className="locked-text-pad">
              One or more of your pots has a change underway and will reopen
              when your change is complete.
            </p>
          </div>
        ) : (
          ""
        )}
        <Row className="contentBox-gap">
          {individualMembershipData?.memberships?.map((item, index) => {
            return (
              <Col
                key={index}
                className={
                  (item.memberType?.includes("deferred") &&
                    item.status === "locked") ||
                  (item.status === "locked" &&
                    item.strategyName ===
                      "currentInvestmentsAndFuturePayments") ||
                  item.funds?.some(
                    (fund) =>
                      fund.fundName?.toLowerCase() === "cash" &&
                      fund.balancePercentage === 100 //eslint-disable-line
                  )
                    ? "pot-items-locked mb-3"
                    : item.funds.some(
                          (fund) => fund.fundName === "TPT Money Market Fund" //eslint-disable-line
                        )
                      ? "pot-items-locked mb-3"
                      : selected?.membershipId === item.membershipId
                        ? "pot-items mb-3 pot-items-bg"
                        : "pot-items mb-3"
                }
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
              >
                {(item.memberType?.includes("deferred") &&
                  item.status === "locked") ||
                item.funds?.some(
                  (fund) =>
                    fund.fundName?.toLowerCase() === "cash" &&
                    fund.balancePercentage === 100 //eslint-disable-line
                ) ||
                (item.status === "locked" &&
                  item.strategyName ===
                    "currentInvestmentsAndFuturePayments") ||
                item.funds?.some(
                  (fund) => fund.fundName === "TPT Money Market Fund" //eslint-disable-line
                ) ? (
                  <div className="manage-custom-checkbox custom-checkbox-align text-end">
                    <Icons iconname="locked" variant="icon-sixteen-px" />
                  </div>
                ) : (
                  <CustomCheckbox
                    name="pot"
                    potId={index}
                    variantName="manage-custom-checkbox custom-checkbox-align text-end"
                    onChange={() => handleCheck(item)}
                    defaultChecked={
                      selected?.membershipId === item.membershipId
                    }
                  />
                )}
                <p className="pot-value-id">{item.membershipId}</p>
                <p className="pot-value-head">{item.membershipName}</p>
                <p className="pot-total-value">
                  £{addCommas(Math.trunc(item.totalPotValue))}.
                  <span>
                    {(item.totalPotValue % 1).toFixed(2).substring(2)}
                  </span>
                </p>
                {item.funds?.some(
                  (fund) => fund.fundName === "TPT Money Market Fund" //eslint-disable-line
                ) ? (
                  <small className="gp3-style">
                    GP3 holdings are not available to edit.
                  </small>
                ) : (
                  ""
                )}
              </Col>
            );
          })}
        </Row>
        <span className="corrected-date mb-3">
          Figures correct as of {formattedDate}
        </span>
        <Row className="d-flex justify-content-between">
          <Buttons
            name="Cancel"
            className="secondary mt-3"
            handleClick={props.handleManageBackButton}
          />
          <Buttons
            name="Continue"
            className="primary mt-3 me-4"
            handleClick={() =>
              props.handleContinueButton(
                selected.memberships !== undefined
                  ? individualMembershipData
                  : selected //eslint-disable-line
              )
            }
            disabled={
              (individualMembershipData.memberships.length === 1 &&
                individualMembershipData.memberships[0].funds.some(
                  (fund) => fund.fundName === "TPT Money Market Fund" //eslint-disable-line
                )) ||
              individualMembershipData?.memberships?.every(
                (membership) =>
                  membership.funds?.some(
                    (fund) =>
                      fund.fundName === "TPT Money Market Fund" ||
                      fund.fundName === "SIPP TPT Money Market Fund" //eslint-disable-line
                  ) ||
                  (membership.status === "locked" &&
                    membership.strategyName ===
                      "currentInvestmentsAndFuturePayments") //eslint-disable-line
              ) ||
              false
            }
          />
        </Row>
      </div>
    </div>
  );
};

export default ManageMembershipModal;
